import { render, staticRenderFns } from "./WhatsappStatus.vue?vue&type=template&id=aabad606"
import script from "./WhatsappStatus.vue?vue&type=script&lang=js"
export * from "./WhatsappStatus.vue?vue&type=script&lang=js"
import style0 from "./WhatsappStatus.vue?vue&type=style&index=0&id=aabad606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports